import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
export const formBlockContainerStyles = ({ theme, $border, }) => css `
	position: relative;
	display: flex;
	flex-direction: column;

	${$border &&
    css `
		margin: ${pxToRem(theme.spacing[200])} 0;
		padding: ${pxToRem(Number(theme.spacing[200]))};
		padding-bottom: 0;
		border: ${pxToRem(theme.borderWidth[2])} solid ${theme.colors.light.borderPanelStandard};
		border-radius: ${pxToRem(theme.borderRadius.m)};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			margin: ${pxToRem(theme.spacing[300])} 0;
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			margin: ${pxToRem(theme.spacing[400])} 0;

			padding: ${pxToRem(theme.spacing[300])};
			padding-bottom: 0;
		}
	`}

	&:first-of-type {
		margin-top: 0;
	}
`;
export const FormBlockContainer = styled.div `
	${formBlockContainerStyles}
`;
export const formBlockLabelStyles = ({ theme }) => css `
	margin-bottom: ${pxToRem(theme.spacing[200])};
`;
export const FormBlockLabel = styled(Typography).attrs({
    tagName: 'h2',
    variant: 'component-title',
}) `
	${formBlockLabelStyles}
`;
/**
 * FormBlockFieldSet
 */
export const formBlockFieldSetStyles = () => css `
	border: none;
	margin: 0;
	padding: 0;
`;
export const FormBlockFieldSet = styled.fieldset `
	${formBlockFieldSetStyles}
`;
//# sourceMappingURL=form-block.styled.js.map